import {ReactNode} from 'react'
import '../../../../_metronic/assets/css/Login.css'

/**
 * Casca visual compartilhada das telas de auth (login, esqueci senha, redefinir
 * senha, área do cliente...): fundo animado (aurora) + card em glassmorphism.
 * Ver DOCS/auth-visual-refresh.md para o racional de design e o que falta portar.
 */
export function AuthAuroraShell({children}: {children: ReactNode}) {
  return (
    <div className='tr-auth-page d-flex flex-center'>
      <div className='tr-auth-aurora' aria-hidden='true'>
        <span className='tr-auth-blob tr-auth-blob-1' />
        <span className='tr-auth-blob tr-auth-blob-2' />
        <span className='tr-auth-blob tr-auth-blob-3' />
        <span className='tr-auth-grain' />
      </div>

      <div className='tr-auth-glass-card'>{children}</div>
    </div>
  )
}

type AuthBrandHeaderProps = {
  tagline?: string
  /** Selo destacado abaixo do wordmark, pra diferenciar telas parecidas (ex: "Portal do Cliente"). */
  badge?: string
}

/** Símbolo animado ("descolar + encaixar") + wordmark, com tagline e selo opcionais. */
export function AuthBrandHeader({tagline, badge}: AuthBrandHeaderProps) {
  return (
    <div className='d-flex flex-column align-items-center mb-8'>
      <svg
        className='tr-auth-symbol'
        viewBox='0 0 71.57 101.46'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden='true'
        focusable='false'
      >
        <g className='tr-auth-symbol-green'>
          <path
            fill='#b5cf52'
            d='M269.14,435.79a8.87,8.87,0,0,1-3.48.64,3.6,3.6,0,0,1-2.37-1.49,3.24,3.24,0,0,1-.69-2.49,12.58,12.58,0,0,1,1.23-3.29l30.51-51.51c1.31-2.2,2.65-4.56,4.52-7.63,0,0,3.74,4.1,5.07,5.55l21.53,23.58,5.06,5.56L326,412.34l-11.87,20-7-7.72c-2.79-3-8.61-3.76-12.92-1.57l-24.54,12.44c-.17.08-.34.18-.5.27Z'
            transform='translate(-262.11 -370.02)'
          />
        </g>
        <g className='tr-auth-symbol-blue'>
          <path
            fill='#53668c'
            d='M307.09,424.65l7,7.72,14.49,15.86q1.86,2.06,5.07,5.55l-7.85,4L301.3,470.21c-.26.13-.52.24-.78.35-4.22,1.75-9.52.95-12.15-1.93l-2.47-2.71-19-20.87-2.47-2.71c-2.79-3-3-9-.55-13.18a12.45,12.45,0,0,0-1.23,3.29,3.22,3.22,0,0,0,.69,2.49,3.61,3.61,0,0,0,2.37,1.48,8.87,8.87,0,0,0,3.48-.64l.49-.27,24.54-12.44c2.31-1.16,5.34-2.72,7.85-4,0,0,3.77,4.14,5.07,5.56Z'
            transform='translate(-262.11 -370.02)'
          />
        </g>
      </svg>

      <div className='tr-auth-wordmark'>
        <span className='tr-auth-word-task'>Task</span>
        <span className='tr-auth-word-rush'>Rush</span>
      </div>

      {badge && <span className='tr-auth-badge'>{badge}</span>}

      {tagline && <p className='tr-auth-tagline'>{tagline}</p>}
    </div>
  )
}
